import { render, staticRenderFns } from "./TermsAndConditionsText.vue?vue&type=template&id=0086bf36&scoped=true"
import script from "./TermsAndConditionsText.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsText.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsText.vue?vue&type=style&index=0&id=0086bf36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086bf36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0086bf36')) {
      api.createRecord('0086bf36', component.options)
    } else {
      api.reload('0086bf36', component.options)
    }
    module.hot.accept("./TermsAndConditionsText.vue?vue&type=template&id=0086bf36&scoped=true", function () {
      api.rerender('0086bf36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sections/TermsAndConditionsText.vue"
export default component.exports